import { FieldShell } from './FieldShell';
import type { FieldComponentProps } from './types';

export const SingleLineTextField = ({ field, value, error, onChange }: FieldComponentProps) => {
  const max = field.constraints?.max_length;
  return (
    <FieldShell field={field} error={error}>
      <input
        id={field.title}
        type="text"
        className="form-input"
        value={typeof value === 'string' ? value : ''}
        maxLength={typeof max === 'number' ? max : undefined}
        onChange={(e) => onChange(e.target.value)}
      />
    </FieldShell>
  );
};
